import React from 'react';
import '../index.css';
import { ResolutionEditor } from './organisms/ResolutionEditor';
import { StagingRecord, FieldSchema, ValidationRule, RecordData } from '../types';

export interface DataQualityEditorProps {
  record: StagingRecord;
  schema: FieldSchema[];
  rules: ValidationRule[];
  onSave: (id: string, updatedData: RecordData, comment: string, overriddenFields?: string[]) => void;
  onReject?: (id: string, reason: string) => void;
  readOnly?: boolean;
  displayName?: string;
  hideFooter?: boolean;
  mode?: 'resolve' | 'edit';
}

const DataQualityEditorWrapper: React.FC<DataQualityEditorProps> = (props) => {
  return <ResolutionEditor {...props} />;
};

export default DataQualityEditorWrapper;
export { DataQualityEditorWrapper, ResolutionEditor };
export type { StagingRecord, FieldSchema, ValidationRule, RecordData };
